import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DashboardRedirectionService {
  private redirected = false;
  private data: any;

  setData(value: any) {
    this.data = value;
  }
  getData(): any {
    return this.data;
  }

  setRedirected(value: boolean) {
    this.redirected = value;
  }

  wasRedirected(): boolean {
    return this.redirected;
  }
}
